import { Box, Typography } from "@mui/material";
import { useNavigation } from "../../hooks/useNavigation";
import { motion } from "framer-motion";

import { storyData } from '../../compontents/story/StoryData';

interface StoryGridProps {
    numberOfStories?: string;
    landingStyle?: boolean;
}
export default function StoryGrid({numberOfStories, landingStyle}: StoryGridProps) {
    const {goBlogStories} = useNavigation();

    const handleToSingleStory = (title: string) => {
        goBlogStories(title);
    }

    const limit = numberOfStories ? parseInt(numberOfStories) : undefined;
    const filteredStories = storyData
        .filter((s) => s.id)
        .slice(0, limit); 

    const mediumWidth = landingStyle ? "100%" : "730px";

    return (
        <>
            <Box
                component="section"
                sx={{
                    width: { sm: "90%", md: mediumWidth, lg: "1208px" },
                    pl: {md: '20px', lg: 0},
                    pr: {md: '20px', lg: 0},
                    margin: '0 auto'
                }}
            >
                {filteredStories.map((story, i) => (
                    <motion.div
                        key={story.id}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        variants={{
                            hidden: { opacity: 0, y: 40 },
                            visible: { opacity: 1, y: 0 },
                        }}
                        transition={{ duration: 0.6, ease: 'easeOut' }}
                    >
                        <Box
                            key={i}
                            className="story-row tab-indictor"
                            onClick={() => handleToSingleStory(story.title)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleToSingleStory(story.title);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                            aria-label={`Open story: ${story.title}`}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", md: "row" },
                                borderBottom: "1px solid #333",
                                fontWeight: 500,
                                fontSize: 15,
                                pt: "38px",
                                pb: "38px",
                                ml: { xs: '2px', md: '20px', lg: 0 },
                                mr: { xs: '2px', md: '20px', lg: 0 },
                                position: "relative",
                                overflow: "hidden",
                                cursor: { xs: "default", md: "pointer" },
                                outline: "none",
                            }}
                        >
                            <Box
                                className="date-box"
                                sx={{
                                    flex: { md: 1 },
                                    display: "flex",
                                    justifyContent: { xs: "flex-start", md: "left" },
                                    alignItems: "center",
                                    paddingRight: { md: 2, xs: 0 },
                                    marginBottom: { xs: 1, md: 0 },
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    className="date-content"
                                    sx={{
                                    display: "inline-block",
                                    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                    willChange: "transform",
                                    }}
                                >
                                    <Typography sx={{ fontSize: "16px", color: "gray" }}>
                                    {story.date}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                className="title-content"
                                sx={{
                                    flex: { md: 1 },
                                    display: "flex",
                                    justifyContent: { xs: "flex-start", md: "left" },
                                    alignItems: "center",
                                    maxWidth: { md: "65%" },
                                    flexShrink: 0,
                                    transition:
                                    "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), color 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                    willChange: "transform",
                                    marginBottom: { xs: 1, md: 0 },
                                }}
                            >
                                <Typography sx={{ fontSize: { xs: "24px", sm: "28px"} }}>{story.title}</Typography>
                            </Box>

                            <Box
                                className="hover-icon"
                                sx={{
                                    flex: 0.5,
                                    display: { xs: "none", md: "flex" },
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "opacity 0.3s ease, transform 0.3s ease",
                                    opacity: 0,
                                    transform: "translateX(-20px)",
                                    mt: "auto",
                                    mb: "auto",
                                    flexShrink: 0,
                                    willChange: "opacity, transform",
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 256 256"
                                    fill="rgb(190, 230, 112)"
                                    width="32"
                                    height="32"
                                >
                                    <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z" />
                                </svg>
                            </Box>

                            <Box
                                sx={{
                                    flex: { md: 1 },
                                    display: "flex",
                                    justifyContent: { xs: "flex-start", md: "flex-end" },
                                    alignItems: "center",
                                    position: "relative",
                                    flexShrink: 0,
                                }}
                            >
                                <Box
                                    sx={{
                                        background: "rgb(195, 219, 98)",
                                        padding: "6px 16px",
                                        borderRadius: 2,
                                        transition: "background-color 0.3s ease",
                                        whiteSpace: "nowrap"
                                    }}
                                >
                                    <Typography sx={{ fontSize: { xs: "13px", sm: "16px"}, color: "black" }}>
                                    {story.type}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </motion.div>
                ))}
            </Box>
        </>
    );
}